<template>
  <div>
    <el-button
        @click="() => {
          $router.back()
        }"
        type="text"
        style="display:flex"
        icon="el-icon-arrow-left"
      >
      返回
    </el-button>
    <div class="table-box">
      <div class="information">
        <el-image
          :src="informationDto.picUrl"
          :preview-src-list="[informationDto.picUrl]"
        />
        <div style="margin:10px">
          <span>资讯标题：</span>
          <el-button @click="dialogVisible = true" type="text">
            {{ informationDto.title }}
          </el-button>
        </div>
      </div>
      <div class="list">
        <ul>
          <li v-for="(item, index) in answerList" :key="index">
            <p style="margin-bottom:14px;">
              {{ index + 1 }}：{{ item.title }}
              <span v-if="item.type">[{{ item | questionTypeLabelFil }}]</span>
              <span v-if="![17, 18].includes(item.type)">
                （{{ item.isMustFill === 1 ? '必填' : '非必填' }}）
              </span>
            </p>
            <div class="item-p" v-if="item.remark">备注：{{ item.remark }}</div>
            <div
              class="item-p"
              v-if="deal(item.answer) && ![17, 18].includes(item.type)"
            >
              无
            </div>
            <div
              v-else-if="typeof item.answer == 'object' && item.type < 8"
              class="item-p"
            >
              <div
                v-for="(item2, index2) in item.answer"
                :key="index2 + 100"
                v-if="item.answer.length > 0"
              >
                <p v-if="item.type == 5" style="margin-bottom:10px;">
                  {{ item.manyTitleJson[index2] }}：
                </p>
                <p style="margin-bottom:10px;">{{ item2 ? item2 : '无' }}</p>
              </div>
              <div v-else>无</div>
            </div>
            <div class="enclosure" v-else-if="item.type == 8">
              <template
                v-for="(item2, index2) in item.answer"
                v-if="item.answer.length > 0"
              >
                <img
                  v-if="!item2.isPdf"
                  v-amplifyImg="item2.url"
                  :key="index2 + 100"
                  :src="item2.url"
                  alt=""
                />
                <div v-else @click="open(item2.url)" :key="index2 + 100">
                  <img src="//cdn.yxvzb.com/WEB/images/pdf.jpeg" />
                  <span>{{ item2.name }}</span>
                </div>
              </template>
              <div v-else>无</div>
            </div>
            <div
              v-else-if="fileTypeList.includes(item.type)"
              style="display:flex;flex-wrap:wrap;"
            >
              <div
                v-for="(item2, index2) in item.answer"
                :key="index2"
                v-if="item.answer.length > 0"
                style="margin:10px;"
              >
                <img
                  v-amplifyImg="item2.url"
                  v-if="item.type == 13"
                  :key="index2 + 100"
                  :src="item2.url"
                  alt=""
                  style="width:200px;height:200px"
                />
                <el-link
                  v-else
                  :href="item2.url"
                  type="primary"
                  style="margin-bottom:10px;"
                  target="_blank"
                >
                  {{ item2.name }}
                </el-link>
              </div>
            </div>
            <div v-else-if="timeTypeList.includes(item.type)">
              <p>{{ item.answer }}</p>
            </div>
            <div v-else-if="item.type == 16">
              <img
                v-if="item.answer.addressPicUrl"
                :src="item.answer.addressPicUrl"
                style="width:600px;height:343px;"
              />
            </div>
            <div class="item-p" v-else-if="item.type == 20">
              <img
                v-if="item.answer"
                v-amplifyImg="item.answer"
                :src="item.answer"
                alt
                style="margin:5px;"
              />
            </div>
            <pre class="item-p item-pre" v-else>{{ item.answer }}</pre>
          </li>
        </ul>
      </div>
      <el-dialog
        top="10vh"
        title="资讯预览"
        width="414px"
        :visible.sync="dialogVisible"
      >
        <div class="questionnaire-content-preview">
          <iframe
            id="iframe"
            scrolling="auto"
            frameborder="0"
            width="100%"
            height="500px"
            ref="previewIframeRef"
            :src="ifrUrl"
          ></iframe>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { digitalQuestionnaire } from '@/api/ajax';
import { questionType } from '@/config/staticData';
import Config from '@/config/index';

export default {
  data() {
    return {
      answerList: [],
      ifrHeight: '500px',
      dialogVisible: false,
      informationDto: {
        picUrl: '',
        title: ''
      },
      fileTypeList: [8, 9, 10, 11, 12, 13],
      timeTypeList: [14, 15]
    };
  },
  filters: {
    questionTypeFil(v) {
      return (questionType[v] || { label: '' }).label;
    }
  },
  computed: {
    ifrUrl() {
      return `${window.location.protocol}${Config.iframeUrl}/v3/index.html#/digital-questionnaire/detail?platformType=oss&hideQuestion=1&recordId=${this.$route.query.taskId}`;
    }
  },
  methods: {
    open(url) {
      window.open(url);
    },
    deal(v) {
      if (v === null || v === '' || v.length === 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  async created() {
    let { taskId, projectId } = this.$route.query;
    if (taskId && projectId) {
      let {
        data: {
          data: { answerList, informationDto }
        }
      } = await digitalQuestionnaire.taskRecordDetail({
        taskId,
        projectId
      });
      this.informationDto = informationDto;
      this.answerList = answerList.map(item => {
        if (
          item.type == 2 ||
          item.type == 5 ||
          (item.type >= 8 && item.type != 19)
        ) {
          try {
            item.answer = JSON.parse(item.answer);
          } catch (error) {}
          if (item.type == 5) {
            item.manyTitleJson = JSON.parse(item.manyTitleJson);
          }
        }
        return item;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.information {
  display: flex;
  align-items: center;
  margin: 5px;
  >>> .el-image__inner {
    width: 300px !important;
    height: 150px !important;
  }
}
.header {
  font-size: 18px;
  margin-bottom: 32px;
  text-align: left;
  line-height: 20px;
}
.header:before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 20px;
  background: #1989fa;
  vertical-align: middle;
  margin-right: 14px;
}
.title {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}
.item-pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.list {
  text-align: left;
  p {
    font-size: 16px;
  }
  ul {
    li {
      width: 100%;
      border-bottom: 2px solid #f5f5f5;
      margin-bottom: 30px;
      .item-p {
        padding-bottom: 15px;
        padding-left: 20px;
        font-size: 16px;
      }
    }
  }
}
.enclosure {
  display: flex;
  img {
    width: 150px;
    height: 150px;
    margin-right: 35px;
  }
  div {
    position: relative;
    span {
      position: absolute;
      width: 95%;
      bottom: 0;
      left: 0;
      color: #fff;
    }
  }
}
</style>
